import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';

const Navbar = () => {
  const [navbarBg, setNavbarBg] = useState('');
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  // Change navbar background on scroll
  useEffect(() => {
    const handleScroll = () => {
      setNavbarBg(window.scrollY > 50 ? 'bg-black' : '');
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { name: 'Home', to: 'home' },
    { name: 'Offerings', to: 'services' },
    { name: 'Contact Us', to: 'footer' },
  ];

  return (
    <nav className={`fixed top-0 left-0 w-full z-20 transition-colors duration-300 ${navbarBg}`}>
      <div className="container mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center space-x-3">
          <img src="/2.jpg" alt="Logo" className="h-10 w-10 rounded-full object-contain" />
          <a className="text-white font-bold text-2xl" href="#home">
            Self Drive Car Ranchi
          </a>
        </div>

        {/* Hamburger Icon */}
        <button className="block md:hidden text-white" onClick={toggleMenu}>
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>

        {/* Desktop Menu */}
        <ul className="hidden md:flex space-x-8">
          {navItems.map((item, idx) => (
            <li key={idx}>
              <Link
                to={item.to}
                smooth={true}
                duration={500}
                className="text-white font-semibold cursor-pointer"
              >
                {item.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden transition-all duration-300 overflow-hidden ${
          isMenuOpen ? 'max-h-60' : 'max-h-0'
        }`}
      >
        <ul className="flex flex-col items-center bg-black space-y-4 py-4">
          {navItems.map((item, idx) => (
            <li key={idx}>
              <Link
                to={item.to}
                smooth={true}
                duration={500}
                onClick={() => setIsMenuOpen(false)}
                className="text-white font-semibold cursor-pointer"
              >
                {item.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
